export const LEGEND_CATEGORY_KEY = 'base' as const;
export const LEGEND_COMPONENT_KEY = 'legend' as const;
